import { useTranslation } from 'react-i18next';

interface ProductSpecificationsProps {
  specifications?: Record<string, string>;
}

export function ProductSpecifications({
  specifications = {},
}: ProductSpecificationsProps) {
  const specEntries = Object.entries(specifications);

  const { t } = useTranslation('product');

  return (
    <div className="bg-white rounded-lg border border-neutral-200 p-6 shadow-sm">
      <h2 className="text-neut-prim mb-4 font-semibold">
        {t('product.specifications')}
      </h2>

      {specEntries.length > 0 ? (
        <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
          {specEntries.map(([key, value]) => (
            <div
              key={key}
              className="flex items-start justify-between py-2 border-b border-gray-100"
            >
              <dt className="text-sm text-neut-600 font-normal">
                {t(`product.${key}`)}:
              </dt>
              <dd className="text-sm text-neut-prim font-medium text-right max-w-[60%] break-words">
                {value}
              </dd>
            </div>
          ))}
        </dl>
      ) : (
        <p className="text-neutral-500 italic">
          {t('product.no_specifications')}
        </p>
      )}
    </div>
  );
}
